import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import apiUrl from '../../../Apiurl';
//IMPORT SPECIFICI
import BarraBrands from './BarraBrands';
import ListaBrands from './ListaBrands';


function PaginaBrands({
    mobile,
    utente,
    elemento,
    setElemento
}) {

    const urlArea = "/anagrafiche/generica?";
    const tabella = "DAM_Brands";
    const ordinamento = "ORDER BY nome ASC"
    const urlElemento = "/anagrafiche/apriBrand/";
    const elementoBlank = {
        
    }


    ////////////////////       HOOKS GENERICI      ///////////////////////////
    const [lista, setLista] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    const filteredItemsNome = lista.filter(
		item => item.nome && item.nome.toLowerCase().includes(filterText.toLowerCase()),
	);

    ////////////////////       AUTENTICAZIONE      ///////////////////////////
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);
    //////////////////////////////////////////////////////////////////////////

    ////////////////////       FETCH INIZIALE      ///////////////////////////
    const fetchOrdini = async () => {
        setLoading(true);
        const nuoviParams = new URLSearchParams({
            tabella: tabella,
            ordinamento: ordinamento
        })
        const response = await axios.get(apiUrl + urlArea+nuoviParams);
        console.log(response.data)
        setLista(response.data);
        setLoading(false);      
    };

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetchOrdini()
    }, [token]);
    //////////////////////////////////////////////////////////////////////////


    ////////////////////       FETCH ELEMENTO      ///////////////////////////
    const apriElemento = async function(id) {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + urlElemento+id, { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => setElemento(data))
    }
    //////////////////////////////////////////////////////////////////////////

    ////////////////////       CREA ELEMENTO      ///////////////////////////
    const creaNuovoElemento = function(){
        setElemento(elementoBlank)
    }
    //////////////////////////////////////////////////////////////////////////

    return (
        <div>
            <div className='barraelista'>
                    <BarraBrands 
                        elemento={elemento}
                        creaNuovoElemento={creaNuovoElemento}
                        apriElemento={apriElemento}
                        mobile={mobile}
                        utente={utente}
                        filterText={filterText}
                        setFilterText={setFilterText}
                        togliTastoNuovo={false}
                    />
                    {lista && <ListaBrands
                        elemento={elemento}
                        apriElemento={apriElemento}
                        mobile={mobile}
                        utente={utente}
                        lista={filterText.length>1 ? filteredItemsNome : lista}
                        loading={loading}
                    />}
                </div>
        </div>
    )
}

export default PaginaBrands;